module.exports = __webpack_public_path__ + "media/images/icons/flags/MD-6f44f085795f9d625682299a674a3d10.svg";